// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/review.css
// module id = 2569
// module chunks = 2